import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const acceptEventTerms = async (
  { ipAddress, auctionId },
  params = {}
) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}events/${auctionId}/accept-terms`,
    params: { ...params },
    data: { ipAddress },
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default acceptEventTerms;
